const StorageKeys = {
  ARTICLE_DATA: 'wika_articleData',
  QUOTE_ID: 'wika_quote_id',
  LOGINDISCOUNT: 'logInDiscount'
}

export default StorageKeys
